<avd-styling-card-shell [label]="label" [inverseMode]="inverseMode">
    <div token-card-preview class="preview">
        <p class="preview__text" [style.color]="textColor">
            The quick brown fox jumped over the lazy dog
        </p>
    </div>

    <avd-css-variable-snippet
        token-card-snippets
        [snippet]="cssVariableSnippet"
        language="css"
    ></avd-css-variable-snippet>
</avd-styling-card-shell>
